@if (loaderIcon | async) {
<app-loader></app-loader>
}
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <form [formGroup]="checkSetUpForm">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <h5 class="fw-semibold">Check Setup</h5>
                </div>
                <hr />
                <div class="row">
                    <div class="col-12 text-start">
                        <div class="card shadow-sm rounded-3 p-2">
                            <div class="card-body">
                                <h6 class="mb-2 fw-bold">{{'Business Info' | wordReplace }}</h6>

                                <div class="row mb-2 align-items-center">
                                    <div class="col-md-6">
                                        <label class="form-label">Company Name<span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" formControlName="MarketName"
                                            maxlength="100">
                                        @if (checkSetUpForm && checkSetUpForm.get('MarketName').errors ) {
                                        <div class="alert alert-danger"
                                            *ngIf="checkSetUpForm.get('MarketName').errors && (checkSetUpForm.get('MarketName').dirty || checkSetUpForm.get('MarketName').touched)">
                                            <span> Company Name is required</span>
                                        </div>
                                        }
                                    </div>
                                    <div class="col-md-6 d-flex align-items-center mt-2 mt-md-4 mt-md-0">
                                        <input type="checkbox" class="form-check-input me-2" id="defaultCheck"
                                            (change)="changeSetDefaultValue($event)">
                                        <label for="defaultCheck" class="form-check-label">Set Default Value</label>
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <label class="form-label">Address<span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" formControlName="Address"
                                            maxlength="100">
                                        @if(checkSetUpForm && checkSetUpForm.get('Address').errors &&
                                        (checkSetUpForm.get('Address').dirty || checkSetUpForm.get('Address').touched))
                                        {
                                        <div class="alert alert-danger">
                                            <span> Company Name is required</span>
                                        </div>
                                        }
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label class="form-label">City<span class="text-danger">*</span></label>
                                                <input type="text" class="form-control" formControlName="City"
                                                    maxlength="30">
                                                @if(checkSetUpForm && checkSetUpForm.get('City').errors &&
                                                (checkSetUpForm.get('City').dirty ||
                                                checkSetUpForm.get('City').touched)) {
                                                <div class="alert alert-danger">
                                                    <span> Company Name is required</span>
                                                </div>
                                                }
                                            </div>
                                            <div class="col-md-6">
                                                <label class="form-label">State<span
                                                        class="text-danger">*</span></label>
                                                <select id="state" class="form-select" formControlName="State">
                                                    <option [value]="null" disabled>Select</option>
                                                    @for (state of states; track state.StateCode) {
                                                    <option [value]="state.StateCode">{{ state.StateName }}</option>
                                                    }
                                                </select>
                                                @if(checkSetUpForm && checkSetUpForm.get('State').errors &&
                                                (checkSetUpForm.get('State').dirty ||
                                                checkSetUpForm.get('State').touched)) {
                                                <div class="alert alert-danger">
                                                    <span> Company Name is required</span>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col-md-4">
                                        <label class="form-label">Zip Code<span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" formControlName="ZipCode"
                                            maxlength="50">
                                        @if(checkSetUpForm && checkSetUpForm.get('ZipCode').errors &&
                                        checkSetUpForm.get('ZipCode').errors.required &&
                                        (checkSetUpForm.get('ZipCode').dirty || checkSetUpForm.get('ZipCode').touched))
                                        {
                                        <div class="alert alert-danger">
                                            <span> Zip Code is required</span>
                                        </div>
                                        }
                                        @if(checkSetUpForm && checkSetUpForm.get('ZipCode').errors &&
                                        !checkSetUpForm.get('ZipCode').errors.required) {
                                        <div class="alert alert-danger">
                                            <span>Please enter valid Zip Code</span>
                                        </div>
                                        }
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label">Country<span class="text-danger">*</span></label>
                                        <select class="form-select" id="country" formControlName="Country"
                                            (change)="onCountryChange($event, true)">
                                            <option [value]="null" disabled>Select</option>
                                            @for (c of countries; track c.Code) {
                                            <option [value]="c.Code">{{ c.Name }}</option>
                                            }
                                        </select>
                                        @if(checkSetUpForm && checkSetUpForm.get('Country').errors &&
                                        (checkSetUpForm.get('Country').dirty || checkSetUpForm.get('Country').touched))
                                        {
                                        <div class="alert alert-danger">
                                            <span> Country is required</span>
                                        </div>
                                        }
                                    </div>
                                    <div class="col-md-4">
                                        <label class="form-label">Telephone</label>
                                        <ejs-maskedtextbox [mask]="phoneNumberMask" name="telephone" id="mTelephone"
                                            formControlName="Telephone"></ejs-maskedtextbox>
                                    </div>
                                </div>
                                <!-- </form> -->
                            </div>
                        </div>
                        <div class="card shadow-sm rounded-3 p-2 mt-2">
                            <div class="card-body">
                                <h6 class="mb-2 fw-bold">Bank Info</h6>
                                <!-- <form> -->
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <label class="form-label">Bank Name<span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" formControlName="BankName"
                                            maxlength="100">
                                        @if(checkSetUpForm && checkSetUpForm.get('BankName').errors &&
                                        (checkSetUpForm.get('BankName').dirty ||
                                        checkSetUpForm.get('BankName').touched)) {
                                        <div class="alert alert-danger">
                                            <span> Bank Name is required</span>
                                        </div>
                                        }
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Address<span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" formControlName="BankAddress"
                                            maxlength="50">
                                        @if(checkSetUpForm && checkSetUpForm.get('BankAddress').errors &&
                                        (checkSetUpForm.get('BankAddress').dirty ||
                                        checkSetUpForm.get('BankAddress').touched)) {
                                        <div class="alert alert-danger">
                                            <span> Address is required</span>
                                        </div>
                                        }
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col-md-3">
                                        <label class="form-label">City<span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" formControlName="BankCity"
                                            maxlength="30">
                                        @if(checkSetUpForm && checkSetUpForm.get('BankCity').errors &&
                                        (checkSetUpForm.get('BankCity').dirty ||
                                        checkSetUpForm.get('BankCity').touched)) {
                                        <div class="alert alert-danger">
                                            <span> City is required</span>
                                        </div>
                                        }
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label">State<span class="text-danger">*</span></label>
                                        <select class="form-select" formControlName="BankState">
                                            <option [value]="null" disabled>Select</option>
                                            @for (state of bankStates; track state.StateCode) {
                                            <option [value]="state.StateCode">{{ state.StateName }}</option>
                                            }
                                        </select>
                                        @if(checkSetUpForm && checkSetUpForm.get('BankState').errors &&
                                        (checkSetUpForm.get('BankState').dirty ||
                                        checkSetUpForm.get('BankState').touched)) {
                                        <div class="alert alert-danger">
                                            <span> State is required</span>
                                        </div>
                                        }
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label">Zip Code<span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" formControlName="BankZipCode"
                                            maxlength="50">
                                        @if(checkSetUpForm && checkSetUpForm.get('BankZipCode').errors &&
                                        checkSetUpForm.get('BankZipCode').errors.required &&
                                        (checkSetUpForm.get('BankZipCode').dirty ||
                                        checkSetUpForm.get('BankZipCode').touched)) {
                                        <div class="alert alert-danger">
                                            <span> Zip Code is required</span>
                                        </div>
                                        }
                                        @if(checkSetUpForm && checkSetUpForm.get('BankZipCode').errors &&
                                        !checkSetUpForm.get('BankZipCode').errors.required) {
                                        <div class="alert alert-danger">
                                            <span>Please enter valid Zip Code</span>
                                        </div>
                                        }
                                    </div>
                                    <div class="col-md-3">
                                        <label class="form-label">Country<span class="text-danger">*</span></label>
                                        <select class="form-select" formControlName="BankCountry"
                                            (change)="onCountryChange($event, false)">
                                            <option [value]="null" disabled>Select</option>
                                            @for (c of countries; track c.Code) {
                                            <option [value]="c.Code">{{ c.Name }}</option>
                                            }
                                        </select>
                                        @if(checkSetUpForm && checkSetUpForm.get('BankCountry').errors &&
                                        (checkSetUpForm.get('BankCountry').dirty ||
                                        checkSetUpForm.get('BankCountry').touched)) {
                                        <div class="alert alert-danger">
                                            <span> Country is required</span>
                                        </div>
                                        }
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <label class="form-label">Telephone</label>
                                        <ejs-maskedtextbox [mask]="phoneNumberMask" name="telephone" id="bTelephone"
                                            formControlName="BankTelephone"></ejs-maskedtextbox>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Transit Code</label>
                                        <input type="text" class="form-control" formControlName="TransitCode"
                                            maxlength="20">
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <label class="form-label">Routing #</label>
                                        <input type="text" class="form-control" formControlName="RoutingNo"
                                            maxlength="25">
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Account #</label>
                                        <input type="text" class="form-control" formControlName="AccountNo"
                                            maxlength="25">
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <label class="form-label">Current Check #</label>
                                        <!-- maxlength pending/ -->
                                        <input type="text" class="form-control" maxlength="19"
                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                            formControlName="CurrentCheckNumber">
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">Check Orientation<span
                                                class="text-danger">*</span></label>
                                        <select class="form-select" formControlName="CheckOrientation">
                                            <option [value]="null" disabled>Select</option>
                                            @for (item of printOrientationList; track $index) {
                                            <option [value]="item.Id">{{ item.Name }}</option>
                                            }
                                        </select>
                                        @if(checkSetUpForm && checkSetUpForm.get('CheckOrientation').errors &&
                                        (checkSetUpForm.get('CheckOrientation').dirty ||
                                        checkSetUpForm.get('CheckOrientation').touched)) {
                                        <div class="alert alert-danger">
                                            <span> Check Orientation is required</span>
                                        </div>
                                        }
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-check">
                                            <input type="checkbox" class="form-check-input" id="copy1"
                                                formControlName="OnePlusOne">
                                            <label class="form-check-label" for="copy1">One + One Copy</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-check">
                                            <input type="checkbox" class="form-check-input" id="copy2"
                                                formControlName="OnePlusTwo">
                                            <label class="form-check-label" for="copy2">One + Two Copies</label>
                                        </div>
                                    </div>
                                </div>
                                <!-- </form> -->
                            </div>
                        </div>
                        <div class="row mt-2 gx-2">
                            <div class="col-md-8">
                                <div class="card shadow-sm rounded-3 h-100">
                                    <div class="card-body">
                                        <div class="d-flex align-items-center mb-2">
                                            <h6 class="fw-bold mb-0">Print Position</h6>
                                            <div class="form-check ms-2">
                                                <input type="checkbox" class="form-check-input" id="defaultCheck"
                                                    (change)="changeSetDefaultPrintPosition($event.target.checked)">
                                                <label class="form-check-label" for="defaultCheck">
                                                    Set Default Value
                                                </label>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <label class="form-label">X1</label>
                                                <input type="text" class="form-control"
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                    formControlName="X1" maxlength="6">
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">X2</label>
                                                <input type="text" class="form-control"
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                    formControlName="X2" maxlength="6">
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">X3</label>
                                                <input type="text" class="form-control"
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                    formControlName="X3" maxlength="6">
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4">
                                                <label class="form-label">Y1</label>
                                                <input type="text" class="form-control"
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                    formControlName="Y1" maxlength="6">
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">Y2</label>
                                                <input type="text" class="form-control"
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                    formControlName="Y2" maxlength="6">
                                            </div>
                                            <div class="col-md-4">
                                                <label class="form-label">Y3</label>
                                                <input type="text" class="form-control"
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                    formControlName="Y3" maxlength="6">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card shadow-sm rounded-3 h-100">
                                    <div class="card-body">
                                        <div class="mb-2">
                                            <h6 class="fw-bold mb-2">
                                                Upload Market Signature
                                            </h6>
                                            <div class="form-check">
                                                <input type="checkbox" class="form-check-input" id="chkPrintSignature"
                                                    formControlName="PrintSignatureOnChecks">
                                                <label class="form-check-label" for="chkPrintSignature">
                                                    Print Signature on Checks
                                                </label>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-center align-items-center mt-3">
                                            <div class="me-3">
                                                <div class="border rounded-3 bg-light d-flex justify-content-center align-items-center"
                                                    style="width: 150px;height: 75px;border-style: dashed !important;">
                                                    @if(!isDefaultSignature){
                                                    <img [src]="signaturePreviewUrl" alt="Signature"
                                                        class="img-fluid p-2"
                                                        style="max-width: 100%;max-height: 100%;object-fit: contain;">
                                                    } @else {
                                                    <i class="fa fa-image text-secondary" style="font-size: 30px;"></i>
                                                    }
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column">
                                                <button type="button" class="btn btnAS btn-sm mb-2"
                                                    style="min-width: 100px;" (click)="addSignatureClick()">
                                                    ADD
                                                </button>
                                                <button type="button" class="btn btn-outline-secondary btn-sm mb-2"
                                                    style="min-width: 100px;" (click)="removeSignature()"
                                                    [disabled]="!canRemoveSignature">
                                                    REMOVE
                                                </button>
                                                <button type="button" class="btn btn-outline-secondary btn-sm"
                                                    style="min-width: 100px;" (click)="saveCheckSignature()"
                                                    [disabled]="!canSaveSignature">
                                                    SAVE
                                                </button>
                                                <input type="file" id="signatureFileInput" #fileSignatureUpload hidden
                                                    accept=".jpg,.jpeg,.png" (change)="addSignature($event)">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-end my-2">
                        @if (checkSetUpForm.get('CheckSetupId').value == 0) {
                        <ejs-tooltip id='tipCheckSetup' target="#btnCheckSetupSave" (beforeOpen)="onBeforeOpen($event)">
                            <button class="btn btnAS me-1" id="btnCheckSetupSave" [disabled]="checkSetUpForm.invalid"
                                [userPermissionHandler]="createPermissionHandlerData"
                                (click)="saveCheckSetUp()">Save</button>
                        </ejs-tooltip>
                        } @else {
                        <ejs-tooltip id='tipCheckSetup1' target="#btnCheckSetupSave1"
                            (beforeOpen)="onBeforeOpen($event)">
                            <button class="btn btnAS me-1" id="btnCheckSetupSave1" [disabled]="checkSetUpForm.invalid"
                                [userPermissionHandler]="editPermissionHandlerData"
                                (click)="saveCheckSetUp()">Save</button>
                        </ejs-tooltip>
                        }
                        <button class="btn btn-orange" (click)="btnCancel()">Cancel</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>